import { supabase } from "@/integrations/supabase/client";
import type { DisciplineEvent, DisciplineScore } from "./types";

export async function getMyScore(): Promise<DisciplineScore> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error("Not signed in");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any).rpc("discipline_score", { _user_id: user.id });
  if (error) throw error;
  const row = Array.isArray(data) ? data[0] : data;
  return {
    total_points: Number(row?.total_points ?? 0),
    events_count: Number(row?.events_count ?? 0),
    current_streak_days: Number(row?.current_streak_days ?? 0),
    last_event_at: row?.last_event_at ?? null,
  };
}

export async function listMyEvents(limit = 25): Promise<DisciplineEvent[]> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any)
    .from("discipline_events")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(limit);
  if (error) throw error;
  return (data ?? []) as DisciplineEvent[];
}
